import {
  AcademicCapIcon,
  ArrowTrendingUpIcon,
  BeakerIcon,
  BoltIcon,
  CakeIcon,
  CalculatorIcon,
  CameraIcon,
  CheckBadgeIcon,
  ClipboardDocumentCheckIcon,
  EyeDropperIcon,
  EyeIcon,
  FireIcon,
  GiftIcon,
  GlobeAmericasIcon,
  GlobeAsiaAustraliaIcon,
  HandRaisedIcon,
  HeartIcon,
  LightBulbIcon,
  LinkIcon,
  MapIcon,
  MegaphoneIcon,
  MusicalNoteIcon,
  RocketLaunchIcon,
  ScaleIcon,
  ShoppingCartIcon,
  SparklesIcon,
  StarIcon,
  SunIcon,
  TrophyIcon,
  WalletIcon,
} from '@heroicons/vue/24/solid'

// Backend templates store an icon name as a string (chosen by staff in Django
// admin). This maps those names onto Heroicons components. Unknown names fall
// back to the trophy so a banner is never iconless.
const ICON_MAP = {
  AcademicCapIcon,
  ArrowTrendingUpIcon,
  BeakerIcon,
  BoltIcon,
  CakeIcon,
  CalculatorIcon,
  CameraIcon,
  CheckBadgeIcon,
  ClipboardDocumentCheckIcon,
  EyeDropperIcon,
  EyeIcon,
  FireIcon,
  GiftIcon,
  GlobeAmericasIcon,
  GlobeAsiaAustraliaIcon,
  HandRaisedIcon,
  HeartIcon,
  LightBulbIcon,
  LinkIcon,
  MapIcon,
  MegaphoneIcon,
  MusicalNoteIcon,
  RocketLaunchIcon,
  ScaleIcon,
  ShoppingCartIcon,
  SparklesIcon,
  StarIcon,
  SunIcon,
  TrophyIcon,
  WalletIcon,
}

export const ACHIEVEMENT_ICON_NAMES = Object.keys(ICON_MAP)

export const resolveAchievementIcon = (name) => ICON_MAP[name] || TrophyIcon
